/**
 * useGameModalState.js
 *
 * US-007-S1C: Extract modal visibility state from Main.js
 * US-007-S1D: Refined to contain ONLY modal open/close state (no video/billing)
 *
 * PURPOSE:
 *   Encapsulates modal visibility useState hooks that were previously inline in Main.js.
 *   This reduces Main.js line count and centralizes modal state management.
 *
 * INPUTS: None
 *
 * OUTPUTS:
 *   Returns an object with:
 *   - Modal visibility flags (boolean)
 *   - Modal setters (setState functions)
 *
 * INVARIANTS:
 *   - No business logic — just state containers
 *   - No UI rendering — just hooks
 *   - Does NOT contain video meeting or billing state (those belong elsewhere)
 */

import { useState } from "react";

export function useGameModalState() {
  // Modal visibility flags
  const [videoMinutesRunoutModalOpen, setVideoMinutesRunoutModalOpen] = useState(false);
  const [settlementModalEndGameOpen, setSettlementModalEndGameOpen] = useState(false);
  // DC-FE-PLAYERLEFT-TOAST-AND-KICKED-MODAL-001: Modal when user is kicked
  const [kickedModalOpen, setKickedModalOpen] = useState(false);

  return {
    // Modal visibility only
    videoMinutesRunoutModalOpen,
    setVideoMinutesRunoutModalOpen,
    settlementModalEndGameOpen,
    setSettlementModalEndGameOpen,
    kickedModalOpen,
    setKickedModalOpen,
  };
}
